






























































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import { onlyNumber, humanTime, minutesToHours, getWeekdayByDate, acCamargoNetwork, getSnackbarMessage } from '@/utils/common'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import timeGrid from '@fullcalendar/timegrid'
import ptBrLocale from '@fullcalendar/core/locales/pt-br'
import moment from 'moment'
import { PrecaucoesFromTasyTipoEnum, PrecaucoesFromTasy } from '@/types/_'
import { ITriagem, Triagem } from '@/types/implements/Triagem'
import EventBus from '@/plugins/EventBus'
import tippy from 'tippy.js'
import { adicionarDiasUteisComFeriados } from '@/utils/calcularData'
import { buildSurgerySchedulingLimitParams, getInvalidSchedulingDates, isInvalidSchedulingDate } from '@/services/surgery-scheduling-limit.service'

@Component({ components: { FullCalendar } })

export default class ComponentBackofficeConfirmarReservaSala extends Vue {
  $refs!: {
    confirmarTriagemRule: any,
    dtPicker1: any,
  }

  calLoading: boolean = false
  loadEquipamentos: boolean = false
  loadCaixasCirurgicas: boolean = false
  preferredDate = [true]
  invalidSchedulingDates: { data: string }[] = []
  surgeryDateInputMenu: boolean = false

  get calendarLoading() {
    return this.calLoading
  }

  set calendarLoading(val: boolean) {
    this.calLoading = val
  }

  get textFieldProps() {
    return {
      'prepend-icon': 'las la-calendar-alt',
      class: 'edit-hospital-text-grid__input',
    }
  }

  get datePickerProps() {
    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
    }
  }

  get timePickerProps() {
    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      format: '24hr',
    }
  }

  triagem: ITriagem = new Triagem()

  calendarOptions: any = {
    timeZone: 'UTC',
    height: 350,
    locale: ptBrLocale,
    plugins: [resourceTimelinePlugin, interactionPlugin, dayGridPlugin, timeGrid],
    initialView: 'resourceTimeline',
    aspectRatio: 1.5,
    headerToolbar: {
      left: 'today,prev,next',
      center: 'title',
      right: '',
    },
    slotLabelFormat: { hour12: false, hour: '2-digit', minute: '2-digit' },
    slotDuration: '00:30:00',
    editable: false,
    droppable: false,
    selectable: true,
    resourceAreaHeaderContent: 'Salas',
    resourceOrder: 'title',
    resources: this.getReservaSalasResources,
    eventDidMount: this.eventRender,
    customButtons: {
      prev: {
        text: 'Anterior',
        click: async () => {
          const { calendar }: any = this.$refs
          const dateCurrent = moment(calendar.getApi().getDate()).format('YYYY-MM-DD')
          await this.changeDateResource(dateCurrent)
          calendar.getApi().prev()
        },
      },
      next: {
        text: 'Próximo',
        click: async () => {
          const { calendar }: any = this.$refs
          calendar.getApi().next()
          const dateCurrent = moment(calendar.getApi().getDate()).add('day', 1).format('YYYY-MM-DD')
          await this.changeDateResource(dateCurrent)
        },
      },
      today: {
        text: 'Hoje',
        click: () => {
          const { calendar }: any = this.$refs
          calendar.getApi().today()
          const dateCurrent = moment().format('YYYY-MM-DD')
          this.changeDateResource(dateCurrent)
        },
      },
    },
  }

  async onOpen() {
    await this.refreshInvalidSchedulingDates()
  }

  get showModalReservaSala() {
    return this.getReservaSalaStore.modalReservaSala
  }

  set showModalReservaSala(value: boolean) {
    this.getReservaSalaStore.setShowModalReservaSala(value)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get loadingEquipamentos() {
    return this.loadEquipamentos
  }

  set loadingEquipamentos(value: boolean) {
    this.loadEquipamentos = value
  }

  get loadingCaixasCirurgicas() {
    return this.loadCaixasCirurgicas
  }

  set loadingCaixasCirurgicas(value: boolean) {
    this.loadCaixasCirurgicas = value
  }

  campoHabilitado(prop: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop]

      if (response) return !!response.habilitado
    }

    return false
  }

  canEditNumeroLeito() {
    return this.getBackofficeGlobalStore.acoes.permiteEditarLeitoDoPaciente
  }

  canEditNumeroAtendimento() {
    return this.getBackofficeGlobalStore.acoes.permiteEditarNumeroDoAtendimentoAoPacienteNoHospital
  }

  get doctorDeadlineJustification() {
    const { justificativaDePrazo: doctorDeadlineJustification } = this.getBackofficeGlobalStore.solicitacao

    return doctorDeadlineJustification
  }

  get surgeryDateInputProps() {
    const invalidSchedulingDates = this.invalidSchedulingDates.reduce((dateMap, item) => {
      dateMap[item.data] = true
      return dateMap
    }, {})

    const todayDate = new Date(Date.now())
    todayDate.setMonth(todayDate.getMonth() - 3)

    return {
      min: todayDate.toISOString(),
      allowedDates: date => !invalidSchedulingDates[date],
    }
  }

  async onChangeSurgeryDate(date: string) {
    this.syncSurgeryDateText()
    this.surgeryDateInputMenu = false
    await this.getSurgeryRoomsAvailabity()
  }

  async refreshInvalidSchedulingDates() {
    const params = buildSurgerySchedulingLimitParams({
      shouldCheck: !!this.getBackofficeGlobalStore.solicitacao.acoes.verificaLimitadorDeCirurgia,
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      complexity: this.getBackofficeGlobalStore.solicitacao.complexidade,
      roomId: this.roomChecked.data.id,
      surgeryCenterId: this.surgeryCenter.data.id,
    })

    if (!params) return

    this.invalidSchedulingDates = await getInvalidSchedulingDates(params)

    if (isInvalidSchedulingDate(this.invalidSchedulingDates, this.surgeryDate)) {
      EventBus.$emit('setSnackbar', getSnackbarMessage('A data selecionada não é válida para o agendamento dessa cirurgia. Por favor, escolha outra data.', 'error'))

      this.surgeryDate = ''
    }
  }

  get formattedSurgeryDate() {
    return this.surgeryDate ? moment(this.surgeryDate).format('DD/MM/YYYY') : ''
  }

  syncSurgeryDateText() {
    this.surgeryDateText = this.formattedSurgeryDate
  }

  parseSurgeryDateText(value: string) {
    const digits = (value || '').replace(/\D/g, '')

    if (digits.length < 8) return ''

    const parsedDate = moment(digits, 'DDMMYYYY', true)

    return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : ''
  }

  canUseSurgeryDate(date: string) {
    const minimumDate = moment(this.surgeryDateInputProps.min).format('YYYY-MM-DD')

    return date >= minimumDate && this.surgeryDateInputProps.allowedDates(date)
  }

  async onSurgeryDateTextInput(value: string) {
    this.surgeryDateText = value || ''
    const digits = this.surgeryDateText.replace(/\D/g, '')

    if (!digits) {
      this.surgeryDate = ''
      return
    }

    const parsedDate = this.parseSurgeryDateText(value)

    if (!parsedDate) return

    if (!this.canUseSurgeryDate(parsedDate)) {
      EventBus.$emit('setSnackbar', getSnackbarMessage('A data selecionada não é válida para o agendamento dessa cirurgia. Por favor, escolha outra data.', 'error'))
      this.syncSurgeryDateText()
      return
    }

    if (parsedDate === this.surgeryDate) {
      this.syncSurgeryDateText()
      return
    }

    this.surgeryDate = parsedDate
    this.syncSurgeryDateText()
    await this.onChangeSurgeryDate(parsedDate)
  }

  get surgeryWeekday() {
    return this.surgeryDate ? getWeekdayByDate(this.surgeryDate) : ''
  }

  @Watch('surgeryDate')
  onSurgeryDateChangeText() {
    this.syncSurgeryDateText()
  }

  get surgerySuggestedDate() {
    const { healthInsuranceData } = this.getBackofficeGlobalStore
    const sundayIndexWeekDay = 0
    let surgerySuggestedDateObject
    let surgerySuggestedDate

    const {
      prazoEmDiasParaSolicitarCirurgiaComOpme: suggestedSurgeryDateDaysWithOPME,
      prazoEmDiasParaSolicitarCirurgiaSemOpme: suggestedSurgeryDateDaysWithoutOPME,
    } = healthInsuranceData

    if (suggestedSurgeryDateDaysWithOPME && suggestedSurgeryDateDaysWithoutOPME) {
      if (this.surgeryHasOPME) {
        surgerySuggestedDateObject = moment().add(suggestedSurgeryDateDaysWithOPME, 'days')
      } else {
        surgerySuggestedDateObject = moment().add(suggestedSurgeryDateDaysWithoutOPME, 'days')
      }

      surgerySuggestedDate = surgerySuggestedDateObject

      if (surgerySuggestedDateObject.day() === sundayIndexWeekDay) {
        surgerySuggestedDate = surgerySuggestedDate.add(1, 'days')
      }


      return surgerySuggestedDate.format('DD/MM/YYYY')
    }

    return null
  }

  get surgeryHasOPME() {
    return this.getBackofficeGlobalStore.solicitacao.temOpme
  }

  get hasHospitalFromNetwork() {
    return this.getReservaSalaStore.hospitaisRede.length > 0
  }

  // Carrega o catálogo de equipamentos da solicitação e persiste automaticamente
  // os grupos com um único equipamento cadastrado, sem exigir que a pessoa abra
  // o modal "Adicionar Equipamento" manualmente. Assim, a confirmação da reserva
  // só continua bloqueada quando existe uma escolha real a ser feita pelo usuário.
  async resolveEquipamentosAutomaticamente() {
    if (!this.getBackofficeGlobalStore.solicitacao.id) return

    let hospitalId
    const { hospitalId: surgerySolicitationHospitalId } = this.getBackofficeGlobalStore.solicitacao

    if (this.hasHospitalFromNetwork) {
      const { data } = this.hospitalSelecionado
      const { id: hospitalIdFromNetwork } = data

      if (surgerySolicitationHospitalId === hospitalIdFromNetwork) {
        hospitalId = surgerySolicitationHospitalId
      } else {
        hospitalId = hospitalIdFromNetwork
      }
    } else {
      hospitalId = surgerySolicitationHospitalId
    }

    const loadEquipmentRequest = await this.getBackofficeGlobalStore.loadEquipamentos()

    if (loadEquipmentRequest.success) {
      await this.getBackofficeGlobalStore.getEquipmentGroupByHospitalId({ hospitalId, hasHospitalFromNetwork: this.hasHospitalFromNetwork })
      await this.getBackofficeGlobalStore.persistPendingAutoSelectedEquipamentos()
    }

    this.getBackofficeGlobalStore.removeDuplicates()
  }

  @Watch('getBackofficeGlobalStore.solicitacao.id', { immediate: true })
  async onSolicitacaoIdChange(solicitacaoId: string) {
    if (solicitacaoId) {
      await this.resolveEquipamentosAutomaticamente()
    }
  }

  async showModalEquipamentos() {
    this.loadingEquipamentos = true

    await this.resolveEquipamentosAutomaticamente()

    this.getBackofficeGlobalStore.setModal({ name: 'equipamentos', value: true })
    this.loadingEquipamentos = false
  }

  async showModalCaixasCirurgicas() {
    this.loadingCaixasCirurgicas = true
    await this.getBackofficeGlobalStore.getAllCaixasCirurgicasByHospitalId()
    this.getBackofficeGlobalStore.setModal({ name: 'caixaCirurgica', value: true })
    this.loadingCaixasCirurgicas = false
  }

  eventRender(info: any) {
    if (info.event.extendedProps.dataAgendamentoVirtual) {
      const span = document.createElement('span')
      span.setAttribute('class', 'fa fa-building white--text ml-2')
      info.el.appendChild(span)
    }

    // Tooltip for each created event
    // If has description in event
    if (info.event.extendedProps.description) {
      tippy(info.el, {
        content: info.event.extendedProps.description,
        placement: 'top',
      })
    }
  }

  confirmarTriagemRule: any = {
    valid: true,
    numeroReserva: [
      v => !!v || 'O campo n reserva é obrigatório.',
    ],
    surgeryCenterRules: [
      v => (this.canShowSurgeryCenterReservation ? ((!!v && !!v.id) || 'O campo Centro Cirúrgico é obrigatório.') : true),
    ],
    surgeryCenterSalaRules: [
      v => (this.canShowSurgeryCenterReservation ? ((!!v && !!v.id) || this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual || 'O campo sala da cirurgia é obrigatório.') : true),
    ],
    salaRules: [
      v => (!this.canShowSurgeryCenterReservation ? (!!v && !!v.id) || 'O campo sala da cirurgia é obrigatório.' : true),
    ],
    motivoTransferenciaReserva: [
      v => (this.canShowMotivoTransferenciaField ? (!!v || 'O campo motivo da reserva é obrigatório.') : true),
    ],
    surgeryDateRules: [
      v => !!v || 'O campo data da cirurgia é obrigatório.',
    ],
    timeStartRules: [
      v => !!v || 'O campo data da cirurgia é obrigatório.',
      v => this.validaTimeStart(v) || 'O campo data da cirurgia é obrigatório.',
    ],
    timerSurgeryRules: [
      v => !!v || 'O campo tempo da cirurgia é obrigatório.',
    ],
    intervalRoomRules: [
      v => !!v || 'O campo intervalo pós-cirurgia é obrigatório.',
    ],
  }

  dtStart: string = ''
  surgeryDateText: string = ''
  get surgeryDate() { return this.dtStart }
  set surgeryDate(value) { this.dtStart = value }

  timezone: string = ''
  timeStart: string = ''
  event: any = {}
  loaderNumeroReserva: boolean = false
  loadConfirmar: boolean = false
  currentDate: any = moment('2021-02-03', 'YYYY-MM-DD').format('YYYY-MM-DD')
  numeroReservaMessage: string = ''
  opcoesDeDataInformadasPeloMedico: string = ''

  get roomChecked() {
    return this.getReservaSalaStore.roomChecked
  }

  get hospitalSelecionado() {
    return this.getReservaSalaStore.hospitalSelecionado
  }

  get surgeryCenter() {
    return this.getReservaSalaStore.surgeryCenter
  }

  get getCurrentDate() {
    return this.currentDate
  }

  set getCurrentDate(value) {
    this.currentDate = value
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  get getReservaSalasResources() {
    return this.getReservaSalaStore.reservaSalasResource
  }

  get getReservaSalasEvents() {
    return this.getReservaSalaStore.reservaSalasEvent
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get loadingNumeroReserva() {
    return this.loaderNumeroReserva
  }

  set loadingNumeroReserva(value: boolean) {
    this.loaderNumeroReserva = value
  }

  validaTimeStart(value) {
    if (value) return true
    return false
  }

  getDatasPrevistas() {
    const datas = [
      this.getReservaSalaStore.reservaSalaInfo.opcaoDataPrevisto1,
      this.getReservaSalaStore.reservaSalaInfo.opcaoDataPrevisto2,
      this.getReservaSalaStore.reservaSalaInfo.opcaoDataPrevisto3,
    ]
    return datas.filter(e => !['', null, undefined].includes(e)).map(e => humanTime(e)).join(', ')
  }

  get haspitalEnabledSurgeryDateConfiguration() {
    return this.getBackofficeGlobalStore.solicitacao.hospital && this.getBackofficeGlobalStore.solicitacao.hospital.hospitalConfiguraDataSugeridaEmDiasUteis
  }

  get healthInsuranceHasDeadlineDate() {
    const { healthInsuranceData } = this.getBackofficeGlobalStore
    const {
      prazoEmDiasParaSolicitarCirurgiaComOpme: suggestedSurgeryDateDaysWithOPME,
      prazoEmDiasParaSolicitarCirurgiaSemOpme: suggestedSurgeryDateDaysWithoutOPME,
    } = healthInsuranceData

    return (suggestedSurgeryDateDaysWithOPME && suggestedSurgeryDateDaysWithOPME > 0)
      || (suggestedSurgeryDateDaysWithoutOPME && suggestedSurgeryDateDaysWithoutOPME > 0)
  }

  get surgeryDateWorkingDaysBased() {
    const { healthInsuranceData } = this.getBackofficeGlobalStore
    const {
      prazoEmDiasParaSolicitarCirurgiaComOpme: suggestedSurgeryDateDaysWithOPME,
      prazoEmDiasParaSolicitarCirurgiaSemOpme: suggestedSurgeryDateDaysWithoutOPME,
    } = healthInsuranceData

    const dataEnvio = this.getBackofficeGlobalStore.solicitacao.dataEnvio
      ? new Date(String(this.getBackofficeGlobalStore.solicitacao.dataEnvio))
      : new Date()

    if (this.surgeryHasOPME && suggestedSurgeryDateDaysWithOPME && suggestedSurgeryDateDaysWithOPME > 0) {
      return new Intl.DateTimeFormat('pt-BR').format(adicionarDiasUteisComFeriados(suggestedSurgeryDateDaysWithOPME, dataEnvio))
    }

    if (!this.surgeryHasOPME && suggestedSurgeryDateDaysWithoutOPME && suggestedSurgeryDateDaysWithoutOPME > 0) {
      return new Intl.DateTimeFormat('pt-BR').format(adicionarDiasUteisComFeriados(suggestedSurgeryDateDaysWithoutOPME, dataEnvio))
    }

    return ' - '
  }

  changeMotivoTransferenciaReserva() {
    if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())
  }

  async onRoomChange() {
    if (this.$refs.confirmarTriagemRule)  {
      EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())
    }

    if (this.roomChecked.data.id) {
      await this.refreshInvalidSchedulingDates()
    }
  }

  async changeTime() {
    if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())
  }

  async getSurgeryRoomsAvailabity() {
    // Check can't send request withou parameters
    if (
      !this.validadesurgeryDate()
      || !this.getBackofficeGlobalStore.solicitacao.tempoCirurgia
      || !this.getBackofficeGlobalStore.solicitacao.id
    ) {
      return
    }

    this.calendarLoading = true
    const dateChange = moment(this.surgeryDate).format('YYYY-MM-DD')
    const params = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      data: dateChange,
      hora: this.timeStart || null,
      tempoCirurgia: this.getBackofficeGlobalStore.solicitacao.tempoCirurgia,
    }

    const { calendar }: any = this.$refs
    await calendar.getApi().removeAllEvents()

    const res = await this.getReservaSalaStore.getReservaSalas(params)
    if (res.success) {
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      calendar.getApi().gotoDate(dateChange)
      calendar.getApi().render()

      if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Ocorreu um erro ao buscar as reservas.', icon: 'warning', color: '#C62828' })
    }

    this.calendarLoading = false
  }

  validadesurgeryDate() {
    if (!this.surgeryDate) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Data da cirurgia é obrigatório', icon: 'warning', color: '#C62828' })
      return false
    }

    const selectedYear = Number(moment(this.surgeryDate).format('YYYY'))

    if (selectedYear < 2018) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não existem agendamentos anteriores a 2018', icon: 'warning', color: '#C62828' })
      this.surgeryDate = ''
      return false
    }

    if (selectedYear > 9999) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Data inválida', icon: 'warning', color: '#C62828' })
      this.surgeryDate = ''
      return false
    }

    return true
  }

  async loadReservaDeSala() {
    this.calendarLoading = true
    const { dataAgendamento, opcaoDataPrevisto1 } = this.getBackofficeGlobalStore.novaDataSolicitada

    let dataAgendament = ''

    if (!['', null, undefined].includes(dataAgendamento)) {
      // @ts-ignore
      dataAgendament = moment(this.getBackofficeGlobalStore.novaDataSolicitada.dataAgendamento)
    } else if (!['', null, undefined].includes(opcaoDataPrevisto1)) {
      // @ts-ignore
      dataAgendament = moment(this.getBackofficeGlobalStore.novaDataSolicitada.opcaoDataPrevisto1)
    } else {
      // @ts-ignore
      dataAgendament = moment()
    }

    this.surgeryDate = moment(dataAgendament).format('YYYY-MM-DD')
    this.syncSurgeryDateText()

    if (this.getBackofficeGlobalStore.novaDataSolicitada.dataAgendamento) {
      this.timeStart = moment(dataAgendament).format('HH:mm')
    }

    const params = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      data: this.surgeryDate,
      hora: this.timeStart,
      tempoCirurgia: this.getBackofficeGlobalStore.solicitacao.tempoCirurgia,
      hospitalId: this.hospitalSelecionado ? this.hospitalSelecionado.data.id : null,
    }

    const { calendar }: any = this.$refs
    await calendar.getApi().removeAllEvents()

    if (typeof this.getBackofficeGlobalStore.solicitacao.dataAntecedenciaDeInternacao === 'string') {
      this.getBackofficeGlobalStore.solicitacao.dataAntecedenciaDeInternacao = new Date(
        this.getBackofficeGlobalStore.solicitacao.dataAntecedenciaDeInternacao,
      )
    }

    const res = await this.getReservaSalaStore.getReservaSalas(params)
    if (res.success) {
      this.surgeryDate = moment(this.getReservaSalaStore.reservaSalaInfo.dataAgendamento).format('YYYY-MM-DD')
      this.syncSurgeryDateText()

      await calendar.getApi().removeAllEvents()
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      await calendar.getApi().render()
      await calendar.getApi().gotoDate(this.surgeryDate)
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Ocorreu um erro ao buscar as reservas.', icon: 'warning', color: '#C62828' })
    }

    if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())

    this.calendarLoading = false
  }

  async changeDateResource(value: string) {
    // Check can't send request withou parameters
    if (
      !this.validadesurgeryDate()
      || !this.getBackofficeGlobalStore.solicitacao.tempoCirurgia
      || !this.getBackofficeGlobalStore.solicitacao.id
    ) {
      return
    }

    this.calendarLoading = true

    this.surgeryDate = moment(value).format('YYYY-MM-DD')
    this.syncSurgeryDateText()

    const params = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      data: this.surgeryDate,
      tempoCirurgia: this.getBackofficeGlobalStore.solicitacao.tempoCirurgia,
    }
    const { calendar }: any = this.$refs
    await calendar.getApi().removeAllEvents()

    const res = await this.getReservaSalaStore.getReservaSalas(params)
    if (res.success) {
      calendar.getApi().removeAllEvents()
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      calendar.getApi().render()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Ocorreu um erro ao buscar as reservas.', icon: 'warning', color: '#C62828' })
    }

    if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())

    this.calendarLoading = false
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  minutesToHoursUtil(value) {
    return minutesToHours(value)
  }

  async checkNumeroReserva(numeroReserva: string = this.getReservaSalaStore.reservaSalaInfo.numeroAgendamento) {
    this.loadingNumeroReserva = true
    if (numeroReserva) {
      const params: any = {
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
        numeroReserva,
        hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      }

      const response = await this.triagem.getCheckNumeroReserva(params)
      this.loadingNumeroReserva = false
      if (!response.success) {
        this.numeroReservaMessage = ''
        EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro na validação no número de reserva.', icon: 'warning', color: '#C62828' })
        return false
      }

      if (response.success && response.data) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Número de reserva duplicado.', icon: 'warning', color: '#C62828' })
        this.numeroReservaMessage = 'Número de reserva duplicado.'
        return false
      }

      this.numeroReservaMessage = ''
      return true
    }

    this.numeroReservaMessage = 'O campo número de reserva é obrigatório.'
    this.loadingNumeroReserva = false
    return false
  }

  modalReset() {
    this.$refs.confirmarTriagemRule.reset()
    this.getReservaSalaStore.clearReservaSalasResource()
    this.getReservaSalaStore.clearReservaSalaEvent()
    this.getReservaSalaStore.clearSurgeryCenter()
    this.getReservaSalaStore.clearRoomChecked()
    this.getReservaSalaStore.clearCentrosCirurgicos()
    this.getReservaSalaStore.setShowModalReservaSala(false)
    this.numeroReservaMessage = ''
  }

  get precaucoesFromTasyAlergias() {
    const { precaucoesFromTasy } = this.getReservaSalaStore
    return precaucoesFromTasy && precaucoesFromTasy.length > 0
      ? precaucoesFromTasy.filter((obj: PrecaucoesFromTasy) => obj.tipo === PrecaucoesFromTasyTipoEnum.ALERGIA)
      : []
  }

  get precaucoesFromTasyPrecaucoes() {
    const { precaucoesFromTasy } = this.getReservaSalaStore
    return precaucoesFromTasy && precaucoesFromTasy.length > 0
      ? precaucoesFromTasy.filter((obj: PrecaucoesFromTasy) => obj.tipo === PrecaucoesFromTasyTipoEnum.PRECAUCAO)
      : []
  }

  async renderCalendarEvents() {
    if (this.surgeryDate) {
      const { calendar }: any = this.$refs
      await calendar.getApi().removeAllEvents()
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      await calendar.getApi().gotoDate(this.surgeryDate)
      await calendar.getApi().render()
    }
  }

  async virtualDateChange() {
    if (this.canShowSurgeryCenterReservation) {
      await this.getReservaSalaStore.clearRoomChecked()
      await this.getReservaSalaStore.updateReservaSalaResource()
      await this.renderCalendarEvents()
    }
    if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())
  }

  changeHospital() {
    this.getReservaSalaStore.clearCentrosCirurgicos()
    this.getReservaSalaStore.clearSurgeryCenter()
    this.getReservaSalaStore.clearRoomChecked()

    this.equipmentSelectionConfirmed = false
    this.loadReservaDeSala()
  }

  async onSurgeryCenterChange() {
    await this.getReservaSalaStore.clearRoomChecked()
    await this.getReservaSalaStore.updateReservaSalaResource()

    if (this.$refs.confirmarTriagemRule) {
      EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())
    }

    if (this.surgeryCenter.data.id) {
      await this.refreshInvalidSchedulingDates()
    }
  }

  get equipmentSelectionConfirmed() {
    return this.getBackofficeGlobalStore.equipmentSelectionConfirmed
  }

  set equipmentSelectionConfirmed(confirmed: boolean) {
    this.getBackofficeGlobalStore.setEquipmentSelectionConfirmation(confirmed)
  }

  get canShowSurgeryCenterReservation() {
    return this.getReservaSalaStore.centrosCirurgicos.length > 0
  }

  get canSurgeryCenterShowRoomField() {
    return this.getReservaSalaStore.configuracoes.dataVirtualFazReservaDeSala || !this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual
  }

  get canShowGridTime() {
    return this.getReservaSalaStore.configuracoes.dataVirtualFazReservaDeSala || !this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual
  }

  get getDisplayPreReserva() {
    return !this.getReservaSalaStore.configuracoes.dataVirtualFazReservaDeSala && this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual
  }

  get canShowMotivoTransferenciaField() {
    return this.getReservaSalaStore.configuracoes.informaMotivoTransferenciaReserva
  }

  get motivosTransferenciaReserva() {
    return this.getReservaSalaStore.motivosTransferenciaReserva
  }


  tipoCentroCirurgicoAcCamargo(value: string = '') {
    const isAcCamargo = acCamargoNetwork(this.getBackofficeGlobalStore.solicitacao.hospitalId)
    switch (value) {
      case 'Geral':
        return `Geral${isAcCamargo ? ' (CC Antônio Prudente ou CC Tamandaré)' : ''}`
      case 'Ambulatorial':
        return `Ambulatorial${isAcCamargo ? ' (CCA Pires da Mota)' : ''}`
      case 'HospitalDia':
        return `Hospital Dia${isAcCamargo ? ' (CC Pires da Mota)' : ''}`
      case 'Hemodinamica':
        return 'Hemodinâmica'
      case 'Radioterapia':
        return 'Radioterapia'
      case 'SalaDePequenosProcedimentos':
        return 'Sala de pequenos procedimentos'
      default:
        return value
    }
  }
}
